import axios from '../helper/axios'
const state = {
  incoming_rintone : new Audio('/music/alert.mp3'),
  is_msg_expand : 1,
  infodesk_messages : [],
  unread_counter : 0,
  selected_chat_user : null,
  is_private_chat : false,
  private_messages : [],
  selected_private_user : null,
  quick_notifications : []
}
const getters = {
  existingPrivateMembers: state => {
    return state.private_messages
  },
  unreadTotalCount : state => {
    let totalUnread = 0
    state.private_messages.map((attendee) => {
      totalUnread += attendee.total_unread_msg
    })
    return totalUnread
  }
}
const actions = {
  getInfoDeskMessage({commit}){
    axios.get('infodesk/get_my_message')
    .then((data) => {
      let messages = data.data.data
      commit('setInitialData',messages)
    })
  },
  getPrivateMessages({commit}) {
    axios.get('attendee/chat_member')
    .then((data) => {
      let messages = data.data.data
      commit('setInitialPrivateMessages',messages);
    })
  }
}
const mutations = {
  setInitialData(state,data){
    state.infodesk_messages = data
  },
  increaseCounter(state){
    state.unread_counter++
  },
  setChatUser(state,data) {
    state.selected_chat_user = data
  },
  setChatPrivate(state,data) {
    state.is_private_chat = data
  },
  setInitialPrivateMessages(state,data) {
    state.private_messages = data
  },
  setTempPrivateMessage(state,data) {
    if(state.private_messages.length){
      let found = state.private_messages.filter((attendee) => {
        return attendee.attendee_id == data.attendee_id
      }).length
      if(found == 0) {
        state.private_messages.push(data)
      }
    } else {
      state.private_messages.push(data)
    }
  },
  setPrivateChatUser(state,data) {
    state.selected_private_user = data
  },
  setExpandBox(state,data) {
    state.is_msg_expand = data
  },
  addNotification(state,data){
    state.quick_notifications.push(data)
    state.incoming_rintone.play()
    if(!data.data.no_timeout){
      setTimeout(()=> {
        if(state.quick_notifications.length){
          state.quick_notifications.pop()
        }
      },7000)
    }
  },
  updateUnreadCounter(state,data){
    state.private_messages = state.private_messages.map((attendee) => {
      if(attendee.attendee_id == data.send_by){
        attendee.total_unread_msg++
      }
      return attendee
    })
  },
  clearReadCount(state,attendee_id) {
    state.private_messages = state.private_messages.map((attendee) => {
      if(attendee.attendee_id == attendee_id){
        attendee.total_unread_msg = 0
      }
      return attendee
    })
  },
  // removeTemp(state,attendeeE) {
  //   state.private_messages = state.private_messages.filter((attendee) => {
  //     return attendee.attendee_id != attendeeE.attendee_id
  //   })
  // }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}